import { Redo2, Undo2 } from 'lucide-react'
import { useEditSession } from '@/core/store/editSession'
import { selectCanRedo, selectCanUndo } from '@/core/store/selectors'
import { TEST_IDS } from '@/lib/testIds'
import { Button } from '@/ui/shadcn/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/ui/shadcn/tooltip'

export function UndoRedoButtons() {
  const canUndo = useEditSession(selectCanUndo)
  const canRedo = useEditSession(selectCanRedo)
  const undo = useEditSession((state) => state.undo)
  const redo = useEditSession((state) => state.redo)

  return (
    <div className="flex items-center gap-1" aria-label="Edit history controls">
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            disabled={!canUndo}
            onClick={undo}
            aria-label="Undo"
            data-testid={TEST_IDS.undo}
          >
            <Undo2 aria-hidden="true" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>Undo (Ctrl+Z)</TooltipContent>
      </Tooltip>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            disabled={!canRedo}
            onClick={redo}
            aria-label="Redo"
            data-testid={TEST_IDS.redo}
          >
            <Redo2 aria-hidden="true" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>Redo (Ctrl+Shift+Z)</TooltipContent>
      </Tooltip>
    </div>
  )
}
